// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IMessagesRequest,
  TMessagesModel,
  IMappers,
  TMessagesResponse,
  IMessagesResponse,
  IMessagesResponseError,
} from './types';

export const defaultConfig: TMessagesModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'chats',
  pathApi: '/v2/messages/',
} as TMessagesModel;

export function createMessagesModel(parameters: IMessagesRequest): TMessagesModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IMessagesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IMessagesRequest;
}

export async function fetchMessages<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IMessagesOptions<TResponse200, TResponse400>): Promise<TMessagesResponse | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = await httpApi.fetch(createMessagesModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IMessagesResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IMessagesResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TMessagesResponse;
}
